/** Possible scrollbars ID's:
 * PAGE_CONTENT_MENU_SIDEBAR
 * PAGE_CONTENT_SIDEBAR
 * PAGE_CONTENT_MAIN
 * MODAL_{id}
 * TABLE
 */
export type Scrollbars = string

export type ScrollPosition = {
  scrollTop: number
  scrollLeft: number

  offsetTop: number
  offsetLeft: number
}

export type ScrollSize = {
  scrollWidth: number
  scrollHeight: number

  offsetWidth: number
  offsetHeight: number
}

export interface IWindowOpenParams {
  innerWidth?: number
  innerHeight?: number
  left?: number
  top?: number
}

export enum UtmTags {
  utmSource = 'utm_source',
  utmMedium = 'utm_medium',
  utmCampaign = 'utm_campaign',
  utmTerm = 'utm_term',
  utmContent = 'utm_content',
  gclid = 'gclid',
  fbclid = 'fbclid',
  msclkid = 'msclkid',
  liFatId = 'li_fat_id',
  twclid = 'twclid',
}

export const supportedUtmTags: string[] = [
  UtmTags.utmSource,
  UtmTags.utmMedium,
  UtmTags.utmCampaign,
  UtmTags.utmTerm,
  UtmTags.utmContent,
  UtmTags.gclid,
  UtmTags.fbclid,
  UtmTags.msclkid,
  UtmTags.liFatId,
  UtmTags.twclid,
]
